module.exports = "/packs/period2-129e0ec6a3f84f4958f137cdf20c0aa0.png";